import { getLocalStorage } from '../api/util.js'
const state = {
  token: localStorage['__token'] ? localStorage['__token'] : '',
  expire: localStorage['__expire'] ? localStorage['__expire'] : '',
  loginGo: localStorage['__loginGo'] ? localStorage['__loginGo'] : '',
  accountData: {},
}
export default state
